import React from "react"
import { Link } from "react-router-dom"
import { Card, CardBody, Col, Collapse, Container, Form, Input, Label, Media, Row, Table, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"
import ApiRest from "../../ayudas/apiRest"
import Breadcrumbs from '../../components/Common/Breadcrumb'
import _valid from "../../validations"
import Select from 'react-select'
import { MDBBtn, MDBIcon } from "mdbreact"
import toastr from "toastr"


export default class programarSolicitud extends React.Component {
    constructor(props) {
        super(props);

        this.apiRest = new ApiRest(props);

        this.state = {
            registro: _valid(this.props.location.registro) ? this.props.location.registro : {

            },
            datos: {
                solicitud: undefined,
                fecha_programada: undefined,
                hora_inicio: undefined,
                tipo_solicitud_concurrente: undefined,
                numeroDeDias: 1,
                cantidad: undefined,
                estado: 1,
            },
            colapsar: true,
            listaSolicitud: [],
            solicitud2: undefined,
            dia: undefined,
            dia2: undefined,
            mostrar: false
        };
        this.actualizarValores = this.actualizarValores.bind(this);
        this.actualizarValoresPantalla = this.actualizarValoresPantalla.bind(this);
        this.programar = this.programar.bind(this);

    }

    componentDidMount() {
        this.getSoicitud();
    }

    actualizarValores = (target) => {
        if (_valid(target)) {
            this.setState({
                solicitud2: target,
                datos: { ...this.state.datos, ['solicitud']: target.value }
            });
        } else {
            this.setState({
                solicitud2: undefined,
                datos: { ...this.state.datos, ['solicitud']: undefined }
            });
        }
    }

    limpiarCampos=()=>{
        const { datos } = this.state;
        for (const property in datos) {
            this.borrarEstado(property)
        }
    }

    borrarEstado(name) {
        this.setState(estadoAnterior => ({
            datos: {
                ...estadoAnterior.datos, [name]: ''
            }
        }));
        this.setState(estadoAnterior => ({
            datos: {
                ...estadoAnterior.datos, ['solicitud']: undefined
            },
            solicitud: undefined
        }));
        this.setState({
            solicitud2: undefined
        });
    }

    actualizarValoresPantalla = ({ target: { name, value } }) => {
        /*
        const fecha = new Date();
        let options = {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        };
        console.log(fecha.toLocaleDateString('es-MX', options))
        */
        const f = new Date();
        if (name === 'fecha_programada') {
            if (_valid(value)) {
                if (this.fechaMayorIgualQue(value, this.formatoFecha(f))) {
                    this.setState({
                        mostrar: true
                    })
                    let fecha = value
                    let date = new Date(fecha.replace(/-+/g, '/'));

                    let options = {
                        weekday: 'long',
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                    };
                    let d = date.toLocaleDateString('es-GT', options);
                    let n = date.getDate()
                    d = d.split(',')
                    this.setState({
                        dia: d[0],
                        dia2: n
                    })
                }else{
                    this.setState({
                        mostrar: false
                    })
                    toastr.warning('La fecha de programación no puede ser menor a la fecha actual')
                }
            } else {
                this.setState({
                    mostrar: false
                })
            }
        }
        this.setState(estadoAnterior => ({
            datos: { ...estadoAnterior.datos, [name]: value }
        }));
    }

    fechaMayorIgualQue(fecha1, fecha2) {
        let aFecha1 = fecha1.split('-');
        let aFecha2 = fecha2.split('-');
        let fFecha1 = new Date(aFecha1[0]+' '+aFecha1[1]+' '+aFecha1[2]);
        let fFecha2 = new Date(aFecha2[0]+' '+aFecha2[1]+' '+ aFecha2[2]);
        if (fFecha1 >= fFecha2) {
            return true;
        } else {
            return false;
        }  
    }

    formatoFecha(fecha) {
        let dia = fecha.getDate();
        let mes = fecha.getMonth() + 1;
        let anio = fecha.getFullYear();
        if (dia < 10) {
            dia = '0' + dia;
        }
        if (mes < 10) {
            mes = '0' + mes;
        }
        return anio + '-' + mes + '-' + dia;
    }

    colapsar() {
        this.setState(estadoAnterior => ({ colapsar: !estadoAnterior.colapsar }));
    }

    formatoSelect = valores => valores.data.map(i => ({ value: i.id, label: "Titulo: " + i.titulo + ", Departamento: " + i.asignado_a_nombre }));

    getSoicitud = () => {
        let id = this.apiRest.getLS('du').colaborador.id;
        if (this.apiRest.getRolDeUsuario('ROL_RESPONSABLE_DEPARTAMENTO')) {
            this.apiRest.get('/solicitudesListaDepartamentoConcurrente/' + id).then(response => {
                if (response.exitoso) {
                    this.setState({
                        listaSolicitud: this.formatoSelect(response)
                    });
                }
            })
        } else {
            this.apiRest.get('/solicitudListaConcurrente/' + id).then(response => {
                if (response.exitoso) {
                    this.setState({
                        listaSolicitud: this.formatoSelect(response)
                    });
                }
            })
        }

    }

    verificarDatos = () => {
        const {
            datos
        } = this.state;
        let valido = false;
        let tmp = 0;

        if (_valid(datos.solicitud)) {
            tmp += 1;
        } else {
            toastr.error('Debe seleccionar una solicitud');
        }
        if (_valid(datos.cantidad)) {
            tmp += 1;
        } else {
            toastr.error('Por Favor Ingrese El Número de Veces a Realizar La Tarea');
        }
        if (_valid(datos.numeroDeDias)) {
            tmp += 1;
        } else {
            toastr.error('Por Favor Ingrese El Tiempo de Espera Dias/Horas');
        }
        if (_valid(datos.fecha_programada)) {
            tmp += 1;
        } else {
            toastr.error('Por Favor Ingrese La Fecha de inicio');
        }
        /*if (_valid(datos.hora_inicio)) {
            tmp += 1;
        } else {
            toastr.error('Por Favor Ingrese La Hora de Inicio');
        }*/
        if (_valid(datos.tipo_solicitud_concurrente)) {
            tmp += 1;
        } else {
            toastr.error('Por Favor Ingrese El Tipo de Tiempo de Espera');
        }

        if (tmp === 5) {
            valido = true;
        }
        return valido;
    }

    programar = () => {
        const {
            datos
        } = this.state;

        if (this.verificarDatos()) {
            //console.log(datos);

            this.apiRest.put('/solicitudConcurrente_view/' + datos.solicitud, datos).then(resultado => {
                if (resultado.exitoso) {
                    this.limpiarCampos();
                    toastr.success('Solicitud Programada!');
                } else {
                    toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                }
            });
        }
    }

    render() {
        const {
            registro,
            colapsar,
            listaSolicitud,
            datos,
            solicitud,
            dia,
            dia2,
            mostrar
        } = this.state;

        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Formulario" breadcrumbItem="Concurrencia" />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        <Link onClick={() => this.colapsar()} className="text-dark" to="#">
                                            <div className="p-4">
                                                <Media className="d-flex align-items-center">
                                                    <div className="me-3">
                                                        <i className="uil uil-receipt text-primary h2"></i>
                                                    </div>
                                                    <div className="flex-1 overflow-hidden">
                                                        <h5 className="font-size-16 mb-1">Solicitud Concurrente</h5>
                                                        <p className="text-muted text-truncate mb-0">Por favor, proporciona los datos.</p>
                                                    </div>
                                                    <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                                </Media>
                                            </div>
                                        </Link>
                                        <Collapse isOpen={colapsar}>
                                            <Form>
                                                {
                                                    _valid(listaSolicitud) && listaSolicitud.length > 0 ?
                                                        <div>
                                                            <Row>
                                                                <Col md={8}>
                                                                    <Label htmlFor="" className="form-label">
                                                                        Solicitud
                                                                    </Label>
                                                                    <Select
                                                                        name="solicitud"
                                                                        options={listaSolicitud}
                                                                        value={solicitud ? solicitud : undefined}
                                                                        onChange={this.actualizarValores}
                                                                        className="basic-single"
                                                                        classNamePrefix="select"
                                                                        placeholder="Seleccionar"
                                                                        isClearable={true}
                                                                        isSearchable={true}
                                                                        noOptionsMessage={() => "No hay solicitudes disponibles"}
                                                                    />
                                                                </Col>
                                                            </Row>
                                                            <p />
                                                            <Row>
                                                                <Col md="4">
                                                                    <Label htmlFor="" className="form-label">
                                                                        Fecha de inicio
                                                                    </Label>
                                                                    <Input
                                                                        name="fecha_programada"
                                                                        value={datos.fecha_programada || ""}
                                                                        onChange={this.actualizarValoresPantalla}
                                                                        type="date"
                                                                    />
                                                                </Col>
                                                                {
                                                                    /*
                                                                    <Col md="6">
                                                                    <Label htmlFor="" className="form-label">
                                                                        Hora de inicio
                                                                    </Label>
                                                                    <Input
                                                                        value={datos.hora_inicio || ""}
                                                                        onChange={this.actualizarValoresPantalla}
                                                                        type="time"
                                                                        name="hora_inicio"
                                                                        className="form-control"
                                                                        placeholder="Número"
                                                                    />
                                                                    </Col>
                                                                     */
                                                                }
                                                            </Row>
                                                            <p />
                                                            <Row>
                                                                {
                                                                    mostrar == true ?
                                                                        <Col md="6">
                                                                            <div className="mb-3 mb-4">
                                                                                <Label htmlFor="tipo_solicitud_concurrente" className="form-label">
                                                                                    Repetir ? :
                                                                                </Label>
                                                                                <select
                                                                                    value={datos.tipo_solicitud_concurrente}
                                                                                    onChange={this.actualizarValoresPantalla || ""}
                                                                                    name="tipo_solicitud_concurrente"
                                                                                    className="form-control"
                                                                                >
                                                                                    <option value="">Seleccione una opción</option>
                                                                                    {
                                                                                        /*<option value="1">Dias</option>
                                                                                        <option value="2">Horas</option>
                                                                                        <option value="3">Minutos</option> */
                                                                                    }
                                                                                    <option value="4">Cada Semana el {dia}</option>
                                                                                    <option value="5">Cada Mes el dia {dia2}</option>
                                                                                    <option value='6'>Todos los dias apartir del {dia + ' ' + dia2}</option>
                                                                                </select>
                                                                            </div>
                                                                        </Col>
                                                                        : ' '
                                                                }
                                                                {
                                                                    /*
                                                                    <Col md="6">
                                                                    <div className="mb-3 mb-4">
                                                                        <Label htmlFor="cantidad" className="form-label">
                                                                            Tiempo de Espera Dias/Horas
                                                                        </Label>
                                                                        <Input
                                                                            value={datos.numeroDeDias || 0}
                                                                            onChange={this.actualizarValoresPantalla}
                                                                            name="numeroDeDias"
                                                                            type="number"
                                                                            min="1"
                                                                            className="form-control"
                                                                            placeholder="Número de Días"
                                                                        />
                                                                    </div>
                                                                    </Col>
                                                                     */
                                                                }
                                                            </Row>
                                                            <p />
                                                            <Row>
                                                                <Col lg={4}>
                                                                    <div className="mb-3 mb-4">
                                                                        <Label htmlFor="cantidad" className="form-label">
                                                                            Número de Veces a Realizar Tarea
                                                                        </Label>
                                                                        <Input
                                                                            value={datos.cantidad || 0}
                                                                            onChange={this.actualizarValoresPantalla}
                                                                            name="cantidad"
                                                                            type="number"
                                                                            min="1"
                                                                            className="form-control"
                                                                            placeholder="Número"
                                                                        />
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                        :
                                                        <Row>
                                                            <Col md={4}>
                                                                <Label htmlFor="#" className="form-label">
                                                                    No hay solicitudes disponibles para seleccionar cree una nueva solicitud
                                                                </Label>
                                                            </Col>
                                                            <Col md={4}>
                                                                <MDBBtn className="waves-effect" color="primary" onClick={() => this.props.history.replace({ pathname: '/solicitud', pathnameAnterior: this.pathname })}>
                                                                    <MDBIcon icon="fas fa-clipboard" />{' '}
                                                                    Nueva
                                                                </MDBBtn>
                                                            </Col>
                                                        </Row>
                                                }
                                                <Row>
                                                    <Col lg={12} className="text-end">
                                                        <MDBBtn className="waves-effect" color="danger" onClick={() => { this.props.history.replace('/dashboard') }}>
                                                            <MDBIcon icon="fas fa-arrow-left" />{' '}
                                                            Regresar
                                                        </MDBBtn>
                                                        {' '}
                                                        {
                                                            _valid(listaSolicitud) && listaSolicitud.length > 0 ?
                                                                <MDBBtn className="waves-effect" color="success" onClick={this.programar}>
                                                                    <MDBIcon icon="fas fa-user-check" /> {' '}
                                                                    Listo
                                                                </MDBBtn> :
                                                                ''
                                                        }
                                                    </Col>
                                                </Row>
                                            </Form>
                                        </Collapse>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>

                    </Container>
                </div>

            </React.Fragment>
        );
    }
}